export default __webpack_public_path__ + "static/media/closet5-before2-2048w.ac547958.webp";